import { render, staticRenderFns } from "./Checkmark.vue?vue&type=template&id=1f981dea&"
import script from "./Checkmark.vue?vue&type=script&lang=js&"
export * from "./Checkmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports